// theme.js - GChain Theme (Red/Black/White)

export const THEME = {
  // Background colors
  canvasBackground: '#0d0d0d',
  sidebarBackground: '#2a2a2a',
  panelBackground: '#2a2a2a',

  // Card colors
  cardBackground: '#2a2a2a',
  cardBorder: '#000000',

  // Component state colors (header)
  headerNormal: '#FFFFFF',
  headerWarning: '#FFD700',     // Yellow - approaching compression
  headerCompressed: '#FFA500',  // Orange - in compression

  // Text colors
  textPrimary: '#E0E0E0',
  textSecondary: '#B0B0B0',
  textMuted: '#808080',

  // Accent colors
  accentPrimary: '#DC143C',     // Crimson red - for UI elements
  accentSecondary: '#8B0000',   // Dark red
  accentHover: '#FF1744',       // Bright red
  handleColor: '#3b82f6',       // Blue - for node connection handles

  // Connection lines
  connectionLine: '#ff6b6b',    // Red
  connectionLineHover: '#ff8787',
  connectionLineSelected: '#ff8787',

  // Grid
  gridDots: '#333333',
  gridSpacing: 20,

  // UI elements
  buttonPrimary: '#DC143C',
  buttonSecondary: '#404040',
  buttonHover: '#FF1744',
  buttonDisabled: '#2a2a2a',

  inputBackground: '#1a1a1a',
  inputBorder: '#404040',
  inputBorderFocus: '#DC143C',
  inputText: '#FFFFFF',

  // Status indicators
  success: '#4CAF50',
  warning: '#FFD700',
  error: '#FFA500',
  info: '#2196F3',

  // Annotation colors
  annotationYellow: '#FFF9C4',
  annotationOrange: '#FFE0B2',
  annotationRed: '#FFCDD2',
  annotationCyan: '#B2EBF2',

  // Shadows
  shadowSmall: '0 2px 4px rgba(0, 0, 0, 0.5)',
  shadowMedium: '0 4px 8px rgba(0, 0, 0, 0.6)',
  shadowLarge: '0 8px 16px rgba(0, 0, 0, 0.7)',

  // Border radius
  borderRadiusSmall: '4px',
  borderRadiusMedium: '8px',
  borderRadiusLarge: '12px',

  // Transitions
  transitionFast: '150ms ease',
  transitionMedium: '250ms ease',
  transitionSlow: '350ms ease',

  // Z-index layers
  zIndex: {
    canvas: 1,
    node: 10,
    edge: 5,
    panel: 100,
    modal: 1000,
    tooltip: 2000
  },

  // Font sizes
  fontSize: {
    xs: '10px',
    sm: '11px',
    md: '12px',
    lg: '14px',
    xl: '16px',
    xxl: '20px'
  },

  // Spacing
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px'
  }
};

export default THEME;
